import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { injectIntl, defineMessages } from "react-intl";
import { ConfigSync } from "components";

import * as configActions from "modules/config";

class CtConfigSync extends Component {
  constructor(props) {
    super(props);

    this.state = {
      resultMessage: { success: "", fail: "" },
      showModal: false,
      onProgress: false,
    };
  }

  onToggleModal = () => {
    this.setState({ showModal: !this.state.showModal });
  };

  // 대상자 수동 연동
  targetSync = async () => {
    const { ConfigActions } = this.props;
    this.setState({ onProgress: true });

    try {
      const response = await ConfigActions.targetSync();
      if (response && !response.data.error) {
        this.setState({
          resultMessage: { success: response.data.list, fail: "" },
        });
      } else {
        this.setState({
          resultMessage: { success: "", fail: response.data.error[0].errInfo },
        });
      }
    } catch (error) {
      console.log("targetSync error", error);
    }

    this.setState({ onProgress: false });
    this.onToggleModal();
  };

  render() {
    const { onToggleModal, targetSync } = this;
    const { onProgress, resultMessage, showModal } = this.state;

    return (
      <ConfigSync
        onProgress={onProgress}
        resultMessage={resultMessage}
        showModal={showModal}
        onToggleModal={onToggleModal}
        targetSync={targetSync}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  ConfigActions: bindActionCreators(configActions, dispatch),
});

export default connect(null, mapDispatchToProps)(injectIntl(CtConfigSync));



// WEBPACK FOOTER //
// ./src/script/containers/config/CtConfigSync.js